import React from 'react';
import Footer from '../../../../components/Footer';

/*
 This component is used for the Quest header if "showFooter" is set to true
*/
export default () => {
    return <Footer />;
};
